/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Tab_PrepInputs */



/**
* | output |
* | --- |
* | "Preparation" |
*
* @param {Meeting_Tab_PrepInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_tab_prep = /** @type {((inputs?: Meeting_Tab_PrepInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Tab_PrepInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Voorbereiding")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Préparation")
	return /** @type {LocalizedString} */ ("Preparation")
});